// src/utils/tokenCounter.js
import { doc, runTransaction, increment } from "firebase/firestore";

/**
 * counterKey example:
 *   "gajuwaka_branch_2026-01-27"
 *   "kurmannapalem_branch_2026-01-27"
 */
export const getNextTokenNumber = async (db, counterKey) => {
  const counterRef = doc(db, "counters", `visits_${counterKey}`);
  let tokenNumber = 1;

  await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(counterRef);

    if (!snap.exists()) {
      // first token of the day for this branch
      transaction.set(counterRef, { last_token: 1 });
      tokenNumber = 1;
    } else {
      tokenNumber = snap.data().last_token + 1;
      transaction.update(counterRef, {
        last_token: increment(1),
      });
    }
  });

  return tokenNumber;
};
